const EventsTab = () => {
    return (
        <div>
            No Data
        </div>
    )
}

export default EventsTab
